import React from "react";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const TextOnlyContainer = ({ text, classes = "", nestedElements = [] }) =>
  nestedElements.length ? (
    <div className={classes}>
      {textResolver(text)}
      {nestedElements.map(({ text, classes }, idx) => (
        <div className={classes} key={`${text}-${idx}`}>
          {textResolver(text)}
        </div>
      ))}
    </div>
  ) : (
    <div className={classes}>{textResolver(text)}</div>
  );

export default TextOnlyContainer;
